@if (commentsSorted.length) {
  <div class="comments-list">
    <div class="comments-list-header" (click)="toggleSortOrder()">
      <div class="sort-order">
        <span class="comments-list-header-label">{{ 'dateAdded' | translate }}</span>
        <mat-icon>{{ sortOrder === 'asc' ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
      </div>
      <div class="divider-bottom"></div>
    </div>
    @for (comment of commentsSorted; track comment.id || $index; let last = $last) {
      <app-comment-item
        [comment]="comment"
        [entityType]="entityType"
        [entityId]="entityId"
        [showDivider]="!last"
        [canEditOwnComment]="canEditOwnComment"
        [canDeleteOwnComment]="canDeleteOwnComment"
        [isInPopup]="isInPopup"
        [isPOMode]="isPOMode"
        [adminPrivilege]="adminPrivilege"
        [showDeleteButton]="showDeleteButton"
      ></app-comment-item>
    }
  </div>
} @else {
  <div class="no-comments mt-1">
    {{ 'noComments' | translate }}
  </div>
}
